<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年04月26日 10:45:42 +0800
 * @最后修改时间: 2021-11-26 18:09:36
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Roster\RosterRecord\components\shiftCard2.vue
 -->
<template>
  <v-container
    class="fill-height max-width pa-1 ma-0"
    :class="col != 1 ? '' : ''"
  >
    <!-- 去掉 mrc-grey 灰色背景 buglist829-8 mel-->
    <!-- 人物 -->
    <v-card
      class="
        pa-0
        fill-height
        d-flex
        align-start
        flex-column
        justify-space-between
        flex-grow-1
        align-self-start
      "
      :elevation="0"
      :color="checked ? 'primary lighten-4' : ''"
      tile
      v-if="col == 1"
    >
      <v-card-text
        class="
          white
          max-width
          fill-height
          pa-0
          d-flex
          transparent
          justify-center
          flex-column
          pa-0
          ma-0
        "
      >
        <v-list-item class="grow pa-0 ma-0" dense>
          <v-checkbox
            v-model="checked"
            :ripple="false"
            v-if="iSEdited"
          ></v-checkbox>
          <v-list-item-avatar class="mr-2" color="grey darken-1" size="40">
            <!-- 2020-03-10 bug1459 mel 40->24 -->
            <!-- 2020-11-26  julia 24->40 -->
            <StaffAvatar
              size="40"
              :isTemp="curData.is_temp"
              contentClass="white--text"
              :src="curData.staff_avatar"
              :staff_name="curData.preferred_name"
            />
          </v-list-item-avatar>
          <v-list-item-content class="ma-0 pa-0">
            <v-list-item-title class="text-title text-left table-title"
              >{{ $getCommonLangValue(curData.preferred_name) }}
              <span class="text--secondary text-caption-xs">
                {{ curData.staff_code }}</span
              ></v-list-item-title
            >
            <v-list-item-subtitle
              class="text-left text--secondary table-subtitle"
            >
              {{
                $getCommonLangValue(
                  curData.job_post_name ? curData.job_post_name : ""
                )
              }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-card-text>
    </v-card>
    <v-card
      @click="iSEdited ? null : onTriger()"
      v-else-if="col !== 1 && curShift"
      :elevation="0"
      tile
      :class="isSelected ? 'card-active rounded' : 'card-inactive'"
      class="
        pa-0
        rounded-lg
        max-width
        shift-content
        fill-height
        d-flex
        align-center
        flex-column
        justify-space-between
        flex-grow-1
        align-self-center
      "
      :style="{
        background:
          curShift.shift_uuid !== '' ? curShift.shift_color_code : 'white',
      }"
    >
      <!-- 假期 -->
      <div
        class="swrap-bg fill-height max-width rounded-lg"
        v-if="curShift['ess_att_attendance_master']"
        v-show="Number(curShift['ess_att_attendance_master']['is_holiday'])"
      ></div>
      <v-card-text
        class="
          pa-0
          fill-height
          d-flex
          transparent
          flex-column
          justify-space-between
          rounded-lg
        "
        :style="{
          zIndex: 3,
        }"
      >
        <!-- 格子顶部区域 height:22px-->
        <div
          class="
            transparent
            max-width
            pa-0
            d-flex
            flex-row
            justify-space-between
          "
          style="height: 22px; overflow: hidden"
        >
          <!-- 是否上锁 -->
          <div class="text-left">
            <span
              class="material-icons-round md-18 pl-1 pt-1"
              v-show="Number(curShift.is_locked)"
              >not_interested</span
            >
          </div>
          <v-spacer></v-spacer>
          <!-- 是否有请假备注 -->
          <div class="text-right">
            <v-tooltip
              bottom
              v-if="
                curShift.remarks !== undefined &&
                curShift.remarks !== null &&
                curShift.remarks !== ''
              "
            >
              <template v-slot:activator="{ on, attrs }">
                <span
                  class="material-icons-round red--text md-12"
                  v-on="on"
                  v-bind="attrs"
                  >fiber_manual_record</span
                >
              </template>
              <!-- remark -->
              <span>{{ curShift.remarks }}</span>
            </v-tooltip>
          </div>
        </div>
        <!-- 排版格子中间 height:44px -->
        <v-sheet
          class="
            transparent
            max-width
            pa-0
            text-center
            align-center
            d-flex
            flex-column
            justify-center
          "
          :style="{
            height: '40px',
          }"
        >
          <!-- 新版规则 -->
          <!-- 有考勤记录 -->
          <v-sheet
            class="
              transparent
              max-width
              pa-0
              text-center
              d-flex
              align-center align-self-center
            "
            height="20"
            max-height="22"
            v-if="curShift['ess_att_attendance_master']"
          >
            <div :style="{ flex: 1, width: 0 }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <div
                    class="text-ellipsis-1 px-1 font-weight-bold"
                    v-on="on"
                    v-bind="attrs"
                  >
                    {{
                      curShift["ess_att_attendance_master"]
                        | getText(curShift, getText)
                    }}
                  </div>
                </template>

                <span>
                  {{
                    curShift["ess_att_attendance_master"]
                      | getText(curShift, getText)
                  }}
                </span>
              </v-tooltip>
            </div>
          </v-sheet>
          <!-- 没有考情记录 -->
          <v-sheet
            class="
              transparent
              max-width
              pa-0
              d-flex
              text-center
              align-center align-self-center
            "
            height="20"
            max-height="22"
            v-else
          >
            <div :style="{ flex: 1, width: 0 }" v-if="curShift['shift_uuid']">
              <div class="text-ellipsis-1 px-1">
                {{ curShift.shift_abbr }}
              </div>
            </div>
          </v-sheet>
          <!-- 有地点 -->
          <v-sheet
            class="
              transparent
              max-width
              pa-0
              d-flex
              text-center
              align-center
              text--secondary
            "
            height="20"
            :style="{ fontSize: '12px' }"
            max-height="22"
            v-if="curShift['ess_att_attendance_master']['site_uuid']"
          >
            <div :style="{ flex: 1, width: 0 }">
              <div class="text-ellipsis-1 px-1">
                <span
                  >{{
                    $getCommonLangValue(
                      curShift["ess_att_attendance_master"]["site_abbr"]
                    )
                  }}
                </span>
              </div>
            </div>
          </v-sheet>
          <!-- 新版规则 -->
        </v-sheet>
        <!-- 排班格子底部 height：26px -->
        <v-spacer></v-spacer>
        <div
          class="
            transparent
            max-width
            pa-0
            d-flex
            flex-column
            justify-end
            align-end
          "
          v-if="curShift['ess_att_attendance_master']"
          :style="{ height: '26px' }"
        >
          <div
            class="
              transparent
              max-width
              pa-0
              d-flex
              flex-row
              justify-space-between
            "
            style="height: 20px"
          >
            <div
              class="text-left text--secondary"
              v-if="
                Number(curShift['ess_att_attendance_master']['is_on_leave']) &&
                Number(curShift['ess_att_attendance_master']['is_onduty'])
              "
            >
              <span
                v-for="(item, index) in curShift['ess_att_attendance_master'][
                  'leave_info'
                ]"
                :key="`leave${index}`"
                >{{ $getCommonLangValue(item["leave_type_abbr"])
                }}{{
                  index <=
                  curShift["ess_att_attendance_master"]["leave_info"].length - 2
                    ? ","
                    : ""
                }}</span
              >
            </div>
            <v-spacer></v-spacer>
            <!-- 公共假期-->
            <v-tooltip
              bottom
              v-if="Number(curShift['ess_att_attendance_master']['is_holiday'])"
            >
              <template v-slot:activator="{ on, attrs }">
                <div class="text-right" v-on="on" v-bind="attrs">
                  <span class="material-icons-round md-20 pink--text"
                    >star</span
                  >
                </div>
              </template>
              <span
                v-for="(item, index) in curShift['ess_att_attendance_master'][
                  'holiday_info'
                ]"
                :key="`holiday${index}`"
                >{{
                  $getCommonLangValue(item["holiday_abbr"]) +
                  (index ==
                  curShift["ess_att_attendance_master"]["holiday_info"].length -
                    1
                    ? ""
                    : ",")
                }}</span
              >
            </v-tooltip>
          </div>
          <!-- <v-sheet
            class="max-width rounded-lg align-end"
            tile
            v-if="curShift.ess_att_attendance_master && !isFuture"
            :elevation="0"
            :color="
              Number(curShift.ess_att_attendance_master.is_late) ||
              Number(curShift.ess_att_attendance_master.is_early_leave) ||
              Number(curShift.ess_att_attendance_master.is_absense) ||
              Number(curShift.ess_att_attendance_master.is_missing_punch)
                ? 'red'
                : 'green'
            "
            :height="6"
          /> -->
          <CardLine
            :Master="curShift.ess_att_attendance_master"
            :isFuture="isFuture"
          />
        </div>
      </v-card-text>
    </v-card>
    <v-card
      v-else-if="col !== 1 && curShift == null && curDate !== ''"
      style="overflow: hidden"
      :class="isSelected ? 'card-active rounded-lg' : 'card-inactive'"
      class="
        pa-0
        max-width
        rounded-lg
        fill-height
        d-flex
        align-center
        flex-column
        justify-space-between
        flex-grow-1
        align-self-center
      "
      elevation="0"
    >
      <div class="grey lighten-2 max-width pa-0" style="height: 25px"></div>
      <v-card-text
        class="
          grey
          lighten-2
          max-width
          pa-0
          text-center
          d-flex
          align-center
          justify-center
        "
        :style="{ overflow: 'hidden', height: '42px' }"
      >
        <!-- <v-btn
          icon
          color="grey lighten-3"
          small
          @click="iSEdited ? null : onTriger()"
        >
          <span class="material-icons-round">add</span>
        </v-btn>-->
      </v-card-text>
      <div class="grey lighten-2 max-width pa-0" style="height: 25px"></div>
    </v-card>
    <!-- 
    <RosterShiftDialog
      :key="curShift.uuid+'dialog'"
      v-if="curShift!=null"
      :uuid="curShift.uuid"
      :curShift="curShift"
      :canEdit="Number(curShift.approval_status[0])"
      :shiftList="shiftList"
      :curAllShift="curAllShift"
      @onChangeRemark="(remark)=>curShift.remarks=remark"
      :roster_uuid="roster_uuid"
      :col="curShift.sequence"
      @update="onUpdate"
      :curData="curData"
      :curDate="curDate"
      :show="showDialog"
      @close="showDialog=false"
    />
    <RosterShiftDialog
      :key="col+'noshift'"
      v-else
      :uuid="null"
      :col="col"
      @onChangeRemark="(remark)=>curShift.remarks=remark"
      :roster_uuid="roster_uuid"
      :curShift="curShift"
      :canEdit="true"
      @update="onUpdate"
      :shiftList="shiftList"
      :curAllShift="curAllShift"
      :curData="curData"
      :curDate="curDate"
      :show="showDialog"
      @close="showDialog=false"
    />-->
  </v-container>
</template>
<script>
import dayjs from "dayjs";
var isBetween = require("dayjs/plugin/isBetween");
dayjs.extend(isBetween);
import { mapGetters } from "vuex";
import RosterShiftDialog from "@/Page/EssAdmin/Roster/RosterFormRecord/components/RosterShiftDialog";
export default {
  name: "shiftCard",
  components: { RosterShiftDialog },
  props: {
    roster_uuid: { default: "", type: String },
    col: { default: 0, type: Number },
    curType: { default: 0, type: Number },
    curData: { default: null, type: Object },
    curDate: { default: "", type: String },
    iSEdited: { default: false, type: Boolean },
    shiftList: { default: [], type: Array },
    selectStaffs: { default: [], type: Array },
    allCheck: { default: false, type: Boolean },
    selectStartDate: { default: "", type: String },
    selectEndDate: { default: "", type: String },
  },
  computed: {
    ...mapGetters(["companyLang"]),
    isB() {
      return this.isBetween();
    },
    isSelected() {
      // if (this.isB && this.allCheck && this.checked) {
      //   return true;
      // }
      if (
        this.selectStaffs.indexOf(this.curData.staff_id) != -1 &&
        this.isBetween()
      ) {
        return true;
      } else {
        return false;
      }
    },
    curShift() {
      const that = this;
      var curshift = null;
      if (this.curData !== null && this.curDate !== "") {
        let curTemp = [];
        if (this.curData.rosters) {
          curTemp = this.curData.rosters.filter(
            (ele) =>
              dayjs(ele.roster_utc_datetime).format("YYYY-MM-DD") ===
              this.curDate
          );
        } else {
          this.curData.rosters = [];
        }

        this.shiftLen = curTemp.length;
        this.curAllShift = curTemp;
        if (curTemp.length > 0) {
          curshift = curTemp[0];
        }
      }
      return curshift;
    },
    curText() {
      if (!this.curShift) {
        return "";
      } else {
        if (this.curShift["ess_att_attendance_master"]) {
          if (
            Number(this.curShift["ess_att_attendance_master"]["is_on_leave"]) &&
            !Number(this.curShift["ess_att_attendance_master"]["is_onduty"])
          ) {
            return this.curShift["ess_att_attendance_master"][
              "leave_type_name"
            ];
          }
        }
      }
    },
    //未来
    isFuture() {
      let today = this.$getDateTime(new Date().getTime(), "YYYY-MM-DD");
      if (!this.curDate) return true;
      if (this.$getTimeValue(this.curDate) > this.$getTimeValue(today))
        return true;
      else {
        return false;
      }
    },
  },
  watch: {
    iSEdited() {
      this.checked = false;
    },
    checked(val) {
      const that = this;
      // console.log(this.canChange);
      if (this.canChange) that.$emit("check", that.curData.staff_id, val);
    },
    allCheck(val) {
      const that = this;
      if (val) {
        this.canChange = false;
        this.checked = true;
      } else {
        this.canChange = false;
        this.checked = false;
      }
      this.$Sleep(500).then(() => {
        that.canChange = true;
      });
    },
  },
  mounted() {
    const that = this;
    // console.log(this.curShift);
    // console.log(this.curData);
  },
  data() {
    return {
      maxW: 0,
      shiftLen: 0,
      checked: false,
      canChange: true,
      showDialog: false,
      curAllShift: [],
    };
  },
  filters: {
    getText: function (master, shift, callback) {
      return callback(master, shift);
    },
  },
  methods: {
    getText(master, shift) {
      const that = this;
      let str = "";

      if (!Number(master["is_onduty"]) && Number(master["is_on_leave"])) {
        //  一整天都是放假的时候才所显示假期简称而不显示Shift简称
        let arr = [];
        master["leave_info"].map((item) => {
          arr.push(that.$getCommonLangValue(item["leave_type_abbr"]));
        });
        str = arr.join(",");
        return str;
      } else if (Number(master["is_onduty"]) && Number(master["is_on_leave"])) {
        // 有请假记录的时候， 会把请假UUID对应的简称显示。 和应该要上班的shift, 所有逗号分隔
        // 2021-11-05 brain
        // let arr = [];
        // master["leave_info"].map((item) => {
        //   arr.push(that.$getCommonLangValue(item["leave_type_abbr"]));
        // });
        // str = arr.join(",") + "," + shift["shift_abbr"];
        // return str;
        return shift["shift_abbr"];
      } else if (master["is_adhoc"] === 1 || master["is_adhoc"] === "1") {
        //  灵活班.配置灵活班的时候可以手动家人前序后序。 组合规则是这里显示{prefix}{-}A{-}{suffix}
        str =
          (master["prefix_shift_abbr"]
            ? master["prefix_shift_abbr"] + " - "
            : "") +
          shift["shift_abbr"] +
          (master["suffix_shift_abbr"]
            ? " - " + master["suffix_shift_abbr"]
            : "");
        return str;
      } else if (shift["shift_uuid"]) {
        str = shift["shift_abbr"];
        return str;
      }
    },
    onUpdate: function (uuids, shiftlist) {
      const that = this;
      this.showDialog = false;
      if (this.curShift == null) {
        shiftlist.forEach((item, index) => {
          that.curData.rosters.push({
            approval_status: [1, 0, 0, 0],
            color_code: item.color_code,
            effective_end_time_zone: item.effective_end_time_zone,
            effective_start_time_zone: item.effective_start_time_zone,
            effective_utc_end_date: item.effective_utc_end_date,
            effective_utc_start_date: item.effective_utc_start_date,
            end_time_time_zone: item.end_time_time_zone,
            end_utc_time: item.end_utc_time,
            ess_att_attendance_master: null,
            is_locked: "0",
            remarks: null,
            roster_form_record_uuid: that.roster_uuid,
            roster_time_zone: item.start_time_time_zone,
            roster_utc_datetime: dayjs(that.curDate).format(
              "YYYY-MM-DD HH:mm:ss"
            ),
            sequence: that.col.toString(),
            shift_abbr: item.shift_abbr,
            shift_description: item.shift_description,
            shift_name: item.shift_name,
            shift_property_group_uuid: item.shift_property_group_uuid,
            shift_remark: item.remarks,
            shift_type_uuid: item.shift_type_uuid,
            shift_uuid: item.shift_uuid,
            staff_avatar: that.curData.staff_avatar,
            preferred_name: that.curData.preferred_name,
            staff_id: that.curData.staff_id,
            start_time_time_zone: item.start_time_time_zone,
            start_utc_time: item.start_utc_time,
            total_working_minutes: item.total_working_minutes,
            uuid: uuids[index],
          });
        });
      } else {
        var curuuids = [];
        this.curAllShift.forEach((item, index) => {
          curuuids.push(item.uuid);
        });
        var tempShift = this.curAllShift[0];
        that
          .$Request({
            method: "POST",
            table: "ess_att_roster_form_records_detail_roster",
            url: "/roster-record-roster/delete-roster-record-roster-table/",
            data: {
              uuids: curuuids.join(","),
            },
          })
          .then((res) => {
            that.$showMessage({
              text: that.$t(
                "message_essweb_system_operation_sucess_deleteLabel"
              ),
              type: "success",
            });
            if (that.curData.rosters) {
              that.curData.rosters.splice(
                that.curData.rosters.indexOf(tempShift),
                1
              );
            }
            // });
            shiftlist.forEach((item, index) => {
              that.curData.rosters.push({
                application_holiday_message:
                  tempShift.application_holiday_message,
                approval_status: tempShift.approval_status,
                color_code: item.color_code,
                effective_end_time_zone: item.effective_end_time_zone,
                effective_start_time_zone: item.effective_start_time_zone,
                effective_utc_end_date: item.effective_utc_end_date,
                effective_utc_start_date: item.effective_utc_start_date,
                end_time_time_zone: item.end_time_time_zone,
                end_utc_time: item.end_utc_time,
                ess_att_attendance_master: tempShift.ess_att_attendance_master,
                is_locked: "0",
                remarks: tempShift.remarks,
                roster_form_record_uuid: that.roster_uuid,
                roster_time_zone: item.start_time_time_zone,
                roster_utc_datetime: dayjs(that.curDate).format(
                  "YYYY-MM-DD HH:mm:ss"
                ),
                sequence: tempShift.sequence,
                shift_abbr: item.shift_abbr,
                shift_description: item.shift_description,
                shift_name: item.shift_name,
                shift_property_group_uuid: item.shift_property_group_uuid,
                shift_remark: item.remarks,
                shift_type_uuid: item.shift_type_uuid,
                shift_uuid: item.shift_uuid,
                staff_avatar: that.curData.staff_avatar,
                preferred_name: that.curData.preferred_name,
                staff_id: that.curData.staff_id,
                start_time_time_zone: item.start_time_time_zone,
                start_utc_time: item.start_utc_time,
                total_working_minutes: item.total_working_minutes,
                uuid: uuids,
              });
            });
          })
          .catch((err) => {
            that.$showMessage({
              title: this.$t("message_essweb_form_textField_errNoticeTitle"),
              type: "error",
              text: err,
            });
          });
      }
    },
    onTriger: function () {
      if (this.curShift) {
        if (Number(this.curShift.is_locked)) {
          this.$showMessage({
            title: this.$t("message_essweb_form_textField_noticeTitle"),
            text: this.$t("message_essweb_rosterFormRecord_form_isLockLabel"),
            type: "warning",
          });
          return false;
        }
        // 2021-04-21  不判断打卡了，考勤上锁和这一天有审批记录(审批中和审批通过)的都不可以改shift   dave luo&brain
        // else if (this.curShift["ess_att_attendance_master"]) {
        //   if (
        //     !this.curShift["ess_att_attendance_master"][
        //       "actual_punch_in_uuid"
        //     ] &&
        //     !this.curShift["ess_att_attendance_master"]["actual_punch_out_uuid"]
        //   ) {
        //     this.$emit("onShift", this.curData, this.curDate);
        //     // this.$getDateTime(
        //     //     this.curShift["utc_att_date"],
        //     //     "YYYY-MM-DD HH:mm:ss"
        //     //   )
        //   } else {
        //     this.$showMessage({
        //       title: this.$t("message_essweb_form_textField_noticeTitle"),

        //       text: this.$t(
        //         "message_essweb_rosterFormRecord_form_canNotEditLabel"
        //       ),
        //       type: "warning",
        //     });
        //     return false;
        //   }
        // }
        else {
          this.$emit("onShift", this.curData, this.curDate);
        }
      } else {
        this.$emit("onShift", this.curData, this.curDate);
      }
    },
    sliceStr: function (str) {
      if (this.curType == 7) {
        if (str.length < 12) {
          return str;
        } else {
          return (
            str.slice(0, 5) + "..." + str.slice(str.length - 5, str.length)
          );
        }
      }
      if (this.curType == 14) {
        if (str.length < 8) {
          return str;
        } else {
          return (
            str.slice(0, 4) + "..." + str.slice(str.length - 4, str.length)
          );
        }
      }
    },
    isBetween: function () {
      if (!this.selectStartDate || !this.selectEndDate) return false;
      return dayjs(this.curDate).isBetween(
        this.selectStartDate,
        this.selectEndDate,
        null,
        "[]"
      );
    },
  },
};
</script>
<style scoped>
.swrap-bg {
  position: absolute;
  background: rgba(0, 0, 0, 0.3);
  background-image: repeating-linear-gradient(
    -45deg,
    hsla(0, 0%, 100%, 0.3),
    hsla(0, 0%, 100%, 0.3) 7.5px,
    transparent 0,
    transparent 15px
  );
  transform: scale(1.04);
  opacity: 0.6;
  z-index: 2;
}
.card-active {
  border: 2px solid var(--main-color);
  box-sizing: border-box;
}
.card-inactive {
  border: 2px solid transparent;
  border-bottom: none;
  box-sizing: border-box;
}
</style>
